module.exports = __webpack_public_path__ + "img/client-logo-8.080a4c71.png";